import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
  children: ReactNode;
  style?: CSSProperties;
  padding?: number | string;
}

export function Card({ children, style, padding = 20, ...rest }: Props) {
  return (
    <div
      {...rest}
      style={{
        background: 'var(--bg-elev)',
        border: '1px solid var(--line)',
        borderRadius: 'var(--r-lg)',
        boxShadow: 'var(--shadow-card)',
        padding,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
